import { listStyles } from "@insite/content-library/Widgets/ProductList/ProductListCardList";
import { css } from "styled-components";

listStyles.cardList = {
    gridContainer: {
        gap: 0,
        css: css`
            div[class^="GridOffset"] {
                max-width: 100%;
            }
        `,
    },
};
